import React, { useCallback, useEffect, useState } from "react";
import api from "../../util/panelApi";
import { PageHead, Table, Pager, Tabs, Person, fmt, when } from "./kit";

const SafetyLists = () => {
  const [tab, setTab] = useState("blocks");
  const [page, setPage] = useState(1);
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    const res = tab === "blocks" ? await api.blocks({ page, size: 25 }) : await api.underage();
    if (res?.status) setData(res);
    setLoading(false);
  }, [tab, page]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <>
      <PageHead title="Güvenlik Listeleri" sub="Kullanıcıların birbirini engellemesi ve yaş doğrulamasında 18 altı çıkan hesaplar." />
      <Tabs value={tab} onChange={(t) => { setTab(t); setPage(1); setData({}); }} tabs={[["blocks", "Engellemeler"], ["underage", "18 yaş altı"]]} />
      {tab === "blocks" ? (
        <div className="row">
          <div className="col-lg-8">
            <Table
              loading={loading}
              head={["Engelleyen", "Engellenen", "Sebep", "Tarih"]}
              rows={(data.blocks || []).map((b) => (
                <tr key={b._id}>
                  <td>
                    <Person p={b.blocker} />
                  </td>
                  <td>
                    <Person p={b.blocked} />
                  </td>
                  <td>{b.reason || "—"}</td>
                  <td>{when(b.createdAt)}</td>
                </tr>
              ))}
            />
            <Pager page={page} size={25} total={data.total || 0} onChange={setPage} />
          </div>
          <div className="col-lg-4">
            <div className="card">
              <div className="card-body">
                <h6>En çok engellenenler</h6>
                <p style={{ fontSize: 12, color: "#6B7280" }}>Çok engellenen hesap genelde rahatsız edici davranışın işaretidir; profilini incele.</p>
                {(data.mostBlocked || []).map((m) => (
                  <div key={m.id} className="d-flex justify-content-between align-items-center" style={{ padding: "6px 0", borderBottom: "1px solid #F1F5F9" }}>
                    <Person image={m.image} name={m.name || "—"} />
                    <b>{fmt(m.count)}</b>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <Table
          loading={loading}
          empty="Yaş doğrulamasında reddedilen hesap yok."
          head={["Kullanıcı", "Kod", "Doğum tarihi", "Tarih"]}
          rows={(data.users || []).map((u) => (
            <tr key={u._id}>
              <td>
                <Person image={u.image} name={u.name} />
              </td>
              <td>{u.uniqueId}</td>
              <td>{u.dob || "—"}</td>
              <td>{when(u.updatedAt)}</td>
            </tr>
          ))}
        />
      )}
    </>
  );
};

export default SafetyLists;
